import { useState } from 'react';
import { SEOHead } from '../components/SEOHead';
import { PushNotificationPreview } from '../components/PushNotificationPreview';
import { PUSH_TEMPLATES } from '../utils/push-templates';
import { Bell } from 'lucide-react';

export default function AppNotifications() {
  const [selectedTemplate, setSelectedTemplate] = useState('upload_done');

  const templates = Object.values(PUSH_TEMPLATES);

  return (
    <div className="min-h-screen bg-[var(--color-white)] p-6">
      <SEOHead title="Benachrichtigungen – pixcapture.app" description="Push Benachrichtigungen testen" path="/app/notifications" />
      
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Bell className="h-8 w-8 text-[var(--color-accent)]" />
          <h1 className="text-[24px]">Benachrichtigungen</h1>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-sm mb-2">Vorlage auswählen</label>
            <select
              value={selectedTemplate}
              onChange={(e) => setSelectedTemplate(e.target.value)}
              className="w-full px-4 py-3 border border-[var(--color-light-grey)] rounded-md"
            >
              {templates.map((template) => (
                <option key={template.id} value={template.id}>
                  {template.titleDe}
                </option>
              ))}
            </select>
          </div>

          <div>
            <h3 className="text-sm mb-3">Vorschau</h3>
            {selectedTemplate && PUSH_TEMPLATES[selectedTemplate] && (
              <PushNotificationPreview
                title={PUSH_TEMPLATES[selectedTemplate].titleDe}
                message={PUSH_TEMPLATES[selectedTemplate].messageDe}
                timestamp={new Date()}
                appIcon="📷"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
